import React from 'react';
import '../styles/About.css';
import { ABOUT_DATA } from '../constants/data';

function About() {
  return (
    <section id="about" className="about-section">
      <div className="about-content">
        <div className="about-text">
          <h2>{ABOUT_DATA.title}</h2>
          {ABOUT_DATA.content.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
        <div className="about-image">
          <img src={ABOUT_DATA.image} alt="logo" />
        </div>
      </div>
    </section>
  );
}

export default About;
